import { render } from "./EspaSection.vue?vue&type=template&id=68e38300"
import script from "./EspaSection.vue?vue&type=script&lang=js"
export * from "./EspaSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__